import { Component, ViewChild } from '@angular/core';
import { NgOtpInputComponent } from 'ng-otp-input';
import { ExamineeService } from '../../services/examinee.service';

@Component({
  selector: 'app-assessment-two-fa',
  templateUrl: './assessment-two-fa.component.html',
  styleUrl: './assessment-two-fa.component.scss'
})
export class AssessmentTwoFaComponent {
	@ViewChild(NgOtpInputComponent, { static: false}) ngOtpInput!: NgOtpInputComponent;

	config = {
		allowNumbersOnly: true,
		length: 6,
		isPasswordInput: false,
		disableAutoFocus: true,
	};

	countdown = 60;
	submitted = false;
	timerRunning = false;

	examinee: any = null;
	code = '';
	context = '';

	constructor(private examineeService: ExamineeService) { }

	ngOnInit(): void {
		this.context = this.examineeService.getContext();
		this.examinee = this.examineeService.examineeValue;
		this.timerRunning = true;
		this.startTimer();
	}

	onOtpChange(event: any) {
		this.code = event;
	}

	confirm() {
		this.submitted = true;
		this.ngOtpInput.otpForm.disable();
		
		this.examineeService.verifyTwoFA(this.code).subscribe({
			next: (response: any) => {
				this.examineeService.setToken(response.token);
			},
			error: (err: any) => {
				this.ngOtpInput.otpForm.enable();
				this.submitted = false;
				if (err.err) {
					this.examineeService.toastErrorMessage(err.message, 'Incorrect Code');
				} else {
					this.examineeService.toastErrorMessage(err, 'Verification Error');
				}
			}
		});
	}

	resend() {
		this.timerRunning = true;
		
		this.examineeService.sendVerifyTwoFA().subscribe({
			next: () => {
				this.startTimer();
			},
			error: (err: any) => {
				this.timerRunning = false;
				this.examineeService.toastErrorMessage(err, 'Resend Error');
			}
		});
	}

	startTimer() {
    this.countdown = 60;
    this.doCountdown();
  }

  doCountdown() {
    setTimeout(() => {
      this.countdown--;
      if (this.countdown > 0) {
        this.doCountdown();
      } else {
        this.timerRunning = false;
      }
    }, 1000);
  }
}
